import { Pipe, PipeTransform } from '@angular/core';
import { displayUsPhone } from '../utils/us-phone.util';

/** A stored phone for display: "(555) 123-4567" for US numbers, with or without +1. */
@Pipe({
  name: 'usPhone',
  standalone: true,
})
export class UsPhonePipe implements PipeTransform {
  transform(phone: string | number | null | undefined): string {
    return displayUsPhone(phone == null ? '' : String(phone));
  }
}
